import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const outputs = [
  'A clear account of what is working and what needs attention',
  'Evidence from employees, leaders and existing workplace data',
  'Priority culture risks and pressure points',
  'Practical recommendations',
  'A leadership discussion or action-planning session',
  'A way to measure whether changes are working',
];

const ClientOutputsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="client-outputs-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            className="order-2 lg:order-1"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?auto=format&fit=crop&w=800&q=80"
                alt="Manager and team member discussing operations in a warehouse"
                className="w-full h-[400px] object-cover corner-cut-tr"
              />
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-golden -z-10" />
            </div>
          </motion.div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <motion.h2
              className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-carbon mb-6 tracking-tight"
              {...fadeInUp}
            >
              CLEAR EVIDENCE.<br /><span className="yellow-highlight text-carbon">PRACTICAL</span> DECISIONS.
            </motion.h2>

            <motion.p
              className="text-base text-carbon/80 leading-relaxed mb-8"
              {...fadeInUp}
            >
              The work should leave leadership better able to decide what to maintain, what to
              change and what not to spend money on.
            </motion.p>

            <motion.ul className="space-y-4" {...fadeInUp}>
              {outputs.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-golden flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-carbon/80 leading-relaxed">{item}</span>
                </li>
              ))}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientOutputsSection;
